import * as layerOps from '../../api/Layers/layer-operations';

export default ({
  aois = '',
  emails = '',
  entities = '',
  orthophoto = '',
  owner = '',
  taskName = ''
}) => ({
  _id: '',
  owner,
  createdAt: '',
  updatedA: '',
  label: 'Focused train',
  name: taskName,
  status: '',
  progress: '',
  group: 'AI&Detecction',
  ready: true,
  links: [
    {
      source: 'aois',
      target: 'focusedTrain'
    },
    {
      source: 'entities',
      target: 'focusedTrain'
    },
    {
      source: 'orthophoto',
      target: 'focusedTrain'
    },
    {
      source: 'focusedTrain',
      target: 'output'
    }
  ],
  nodes: [
    {
      x: 50,
      y: 50,
      id: 'aois',
      nodeLabel: 'Areas of interest',
      argName: 'focusedTrain:aois',
      nodeType: 'CONNECTION',
      status: '',
      progress: '',
      connectionParams: {
        temporal: false,
        connector: {
          _id: 'temporal',
          type: 'GeoJSONVirtual',
          ip: '0.0.0.0',
          port: 21,
          user: 'test',
          password: 'test',
          subtype: 'VECTOR',
          fileType: 'GeoJSONVirtual',
          filePath: aois
        },
        source: {
          _id: 'temporal'
        },
        allowedPGTypes: ['VECTOR'],
        allowedFileTypes: ['KML', 'SHAPE', 'GeoJSON'],
        allowedMapServerElementTypes: [],
        createMapServerElement: false
      }
    },
    {
      x: 50,
      y: 150,
      id: 'entities',
      nodeLabel: 'Entities',
      argName: 'focusedTrain:entities',
      nodeType: 'CONNECTION',
      status: '',
      progress: '',
      connectionParams: {
        temporal: false,
        connector: {
          _id: 'temporal',
          type: 'GeoJSONVirtual',
          ip: '0.0.0.0',
          port: 21,
          user: 'test',
          password: 'test',
          subtype: 'VECTOR',
          fileType: 'GeoJSONVirtual',
          filePath: entities
        },
        source: {
          _id: 'temporal'
        },
        allowedPGTypes: ['VECTOR'],
        allowedFileTypes: ['KML', 'SHAPE', 'GeoJSON'],
        allowedMapServerElementTypes: [],
        createMapServerElement: false
      }
    },
    {
      x: 50,
      y: 250,
      id: 'orthophoto',
      nodeLabel: 'orthophoto',
      argName: 'focusedTrain:orthophoto',
      nodeType: 'CONNECTION',
      status: '',
      progress: '',
      connectionParams: {
        temporal: false,
        connector: {
          _id: 'temporal',
          type: 'WMS',
          domain: layerOps.getURL(orthophoto),
          user: 'test',
          password: 'test',
          subtype: 'RASTER',
          fileType: 'GeoTIFF',
          filePath: 'layerName'
        },
        source: {
          _id: 'temporal'
        },
        allowedPGTypes: [],
        allowedFileTypes: ['ECW', 'GeoTIFF'],
        allowedMapServerElementTypes: [],
        createMapServerElement: false
      }
    },
    {
      x: 350,
      y: 150,
      id: 'output',
      nodeLabel: 'output',
      argName: 'focusedTrain:output_layer',
      nodeType: 'CONNECTION',
      status: '',
      progress: '',
      connectionParams: {
        temporal: false,
        connector: {
          _id: 'temporal',
          type: 'FTP',
          ip: '149.202.228.226',
          port: 21,
          user: 'demos_user@srmconsulting.es',
          password: 'S9awVaLBVfEzt7NU',
          subtype: 'VECTOR',
          fileType: 'GeoJSON',
          filePath: `/demo/${taskName}.geojson`
        },
        source: {
          _id: 'temporal'
        },
        allowedPGTypes: ['VECTOR'],
        allowedFileTypes: ['SHAPE', 'KML', 'GeoJSON'],
        allowedMapServerElementTypes: ['WMS', 'TMS', 'GeoJSON'],
        createMapServerElement: false
      }
    },
    {
      x: 200,
      y: 150,
      id: 'focusedTrain',
      nodeLabel: 'FocusedTrain',
      name: 'FocusedTrain',
      nodeType: 'SUBTASK',
      methodUrl: '/AI/skyNet/focused_training',
      argName: 'focusedTrain',
      paramList: [
        {
          id: 'name',
          label: 'name',
          type: 'STRING',
          multiValue: false,
          options: [],
          value: '',
          comments: 'Nombre identificativo del entrenamiento',
          required: true
        },
        {
          id: 'zoom_levels',
          label: 'Zoom levels',
          type: 'STRING',
          multiValue: false,
          options: [],
          value: '[20, 40]',
          comments:
            'Niveles de zoom a crear en formato JSON, en m. e.g. [50, 100] pasos sobre la orto con cuadrículas de 50 y 100 m',
          required: false
        },
        {
          id: 'image_max_size',
          label: 'Image max size',
          type: 'NUMBER',
          multiValue: false,
          options: [],
          value: '256',
          comments: 'Máximo tamaño de imagen a crear',
          required: false
        },
        {
          id: 'image_min_size',
          label: 'Image min size',
          type: 'NUMBER',
          multiValue: false,
          options: [],
          value: '256',
          comments: 'Mínimo tamaño de imagen a crear',
          required: false
        },
        {
          id: 'train_percentage',
          label: 'Train split',
          type: 'NUMBER',
          multiValue: false,
          options: [],
          value: '80',
          comments:
            'Porcentage del total de ejemplos para entrenar. El resto se utilizará para validación',
          required: false
        },
        {
          id: 'empty_prob',
          label: 'Empty samples',
          type: 'NUMBER',
          multiValue: false,
          options: [],
          value: '0.5',
          comments:
            'Probabilidad de añadir un ejemplo vacío. Si es más alta habrá más ejemplos vacíos.',
          required: false
        },
        {
          id: 'epochs',
          label: 'Epochs',
          type: 'NUMBER',
          multiValue: false,
          options: [],
          value: '25',
          comments: 'Épocas. Número de pasadas enteras por todo el conjunto de entrenamiento',
          required: false
        },
        {
          id: 'validation_steps',
          label: 'Validation steps',
          type: 'NUMBER',
          multiValue: false,
          options: [],
          value: '-1',
          comments:
            'Iteraciones en la validación. Si es negativo se hace en todo el conjunto de validación. Si es positivo indica el número de interaciones',
          required: false
        },
        {
          id: 'transfer_learning',
          label: 'Transfer Learning',
          type: 'BOOLEAN',
          multiValue: false,
          options: [],
          value: true,
          comments: 'Utilizar un modelo preentrenado.',
          required: false
        },
        {
          id: 'unfrozen_layers',
          label: 'Unfrozen layers',
          type: 'NUMBER',
          multiValue: false,
          options: [],
          value: 25,
          comments:
            "Solo aplica si 'Transfer Learning' está activado. Si es positivo indica el % de capas descongeladas. Si es negativo indica el número de capas descongeladas empezando por el final",
          required: false
        },
        {
          id: 'is_annealed',
          label: 'Annealing step',
          type: 'BOOLEAN',
          multiValue: false,
          options: [],
          value: true,
          comments:
            "Solo aplica si 'Transfer Learning' está activado. Activa una última etapa de entrenamiento con todas las capas descongeladas y un learning rate muy bajo",
          required: false
        },
        {
          id: 'lr',
          label: 'Learning rate',
          type: 'NUMBER',
          multiValue: false,
          options: [],
          value: 0.0001,
          comments: 'Ratio de aprendizaje (alpha)',
          required: false
        },
        {
          id: 'lr_schedule_type',
          label: 'Learning rate schedule',
          type: 'STRING',
          multiValue: false,
          options: ['constant', 'linear', 'boltzman', 'cauchy'],
          value: 'linear',
          comments: 'Tipo de decaimiento del ratio de aprendizaje',
          required: false
        },
        {
          id: 'lr_constant_epoch',
          label: 'Constant epochs',
          type: 'NUMBER',
          multiValue: false,
          options: [],
          value: 5,
          comments: 'Épocas de ratio de aprendizaje constante antes de aplicar el decaimiento',
          required: false
        },
        {
          id: 'data_aug',
          label: 'Data augmentation',
          type: 'BOOLEAN',
          multiValue: false,
          options: [],
          value: true,
          comments: 'Aplicar técnicas de data augmentation',
          required: false
        },
        {
          id: 'data_aug_args',
          label: 'Data augmentation arguments',
          type: 'STRING',
          multiValue: false,
          options: [],
          value: '{}',
          comments:
            "Solo aplica si 'Data augmentation' está activado. Parámetros para data augmentation. Ver documentación.",
          required: false
        },
        {
          id: 'regularizer',
          label: 'Wight regularization',
          type: 'NUMBER',
          multiValue: false,
          options: [],
          value: 0.0001,
          comments: 'Regularización L1 L2, Si es cero no aplica',
          required: false
        },
        {
          id: 'confidence',
          label: 'confidence',
          type: 'NUMBER',
          multiValue: false,
          options: [],
          value: 0.8,
          comments: 'nivel de confianza para la obtención de nuevas entidades',
          required: true
        }
      ]
    },
    {
      x: 450,
      y: 150,
      id: 'email',
      nodeLabel: 'email',
      name: 'email',
      nodeType: 'SUBTASK',
      methodUrl: '/MG/comunication/send_email',
      argName: 'send_email',
      paramList: [
        {
          id: 'to_addrs',
          label: 'name',
          type: 'STRING',
          multiValue: false,
          options: [],
          value: emails,
          comments:
            'Emails receptores, separados por espacios (example@example.com example1@example.com)',
          required: true
        },
        {
          id: 'email_type',
          label: 'Tipo de email',
          type: 'STRING',
          multiValue: false,
          options: ['success'],
          value: 'success',
          comments: 'Tipo de email a enviar',
          required: true
        },
        {
          id: 'email_parameters',
          label: 'Parámetros del email',
          type: 'STRING',
          multiValue: false,
          options: [],
          value: 'header_message: Gracias por utlizar nuestro servicio de IA.',
          comments:
            'Parámetros para configurar el email. Llave, valor separados por |.Ejemplo: header_message: Este el mensaje de cabecera| ...',
          required: true
        }
      ]
    }
  ]
});
